import { LeagueModel } from "@/models/LeagueModels";
import { BaseRepo } from "./base/BaseRepo";
import { createLeagueMigrationManager } from "@/utils/migrations";


// src/repos/LeaguesRepo.ts
/**
 * Repository for models in the leagues collection
 */
export class LeaguesRepo extends BaseRepo<LeagueModel> {
    protected collectionName = 'leagues';
    protected cacheKeyPrefix = 'league_';

    constructor() {
        super();
        this.setupMigrations(createLeagueMigrationManager());
    }
}